import React, { useState, useRef, useEffect } from 'react';
import { Globe, ChevronDown, ChevronUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../i18n'; // Import our custom function

export const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const languages = [
    { code: 'en', name: 'English', flag: 'https://i.imgur.com/6IkRDRg.jpeg' },
    { code: 'sv', name: 'Swedish', flag: 'https://i.imgur.com/mnS12vc.jpeg' },
    { code: 'no', name: 'Norwegian', flag: 'https://i.imgur.com/BW8gsFf.jpeg' },
    { code: 'da', name: 'Danish', flag: 'https://i.imgur.com/wLCVBJF.jpeg' }
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        className="flex items-center space-x-2 bg-gray-50 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Globe className="w-4 h-4 text-gray-500" />
        <span className="text-sm text-gray-700">
          {languages.find(lang => lang.code === i18n.language)?.name || 'Language'}
        </span>
        {isOpen ? (
          <ChevronUp className="w-4 h-4 text-gray-500" />
        ) : (
          <ChevronDown className="w-4 h-4 text-gray-500" />
        )}
      </button>
      
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-20">
          <div className="py-1">
            {languages.map(lang => (
              <button
                key={lang.code}
                className={`w-full flex items-center px-3 py-2 text-sm hover:bg-gray-50 ${
                  lang.code === i18n.language ? 'bg-gray-50' : ''
                }`}
                onClick={() => {
                  changeLanguage(lang.code); // Use our custom function
                  setIsOpen(false);
                }}
              >
                <img
                  src={lang.flag}
                  alt=""
                  className="w-4 h-4 rounded-full object-cover mr-2"
                />
                <span>{lang.name}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}; 